<template>
  <rect
    class="Rect"
    :transform="`translate(${x}, ${y})`"
    :width="safeWidth"
    :height="safeHeight"
    :fill="fill"
    @click="onClick"
    @mouseover="onMouseover"
    @mouseout="onMouseout"
  />
</template>

<script>
import { defineComponent } from 'vue';

import Datum from './datum.vue';

// This prevents a distracting number of svg errors in the console when
// something is misconfigured.
const safeNumber = (x) => Math.max(0, Number.isNaN(x) ? 0 : x);

export default defineComponent({
  name: 'DatalasRect',

  extends: Datum,

  props: {
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    safeWidth() {
      return safeNumber(this.width);
    },
    safeHeight() {
      return safeNumber(this.height);
    },
  },
});
</script>
